// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3RUgX","title":"Images45_title__3O4sl","images":"Images45_images__2jiLs"};